import {
  numberOnly,
  isEmail,
  isPhone,
  moreThanLength,
  lessThanLength,
  betweenLength,
} from '~components/common/forms/UniversalValidations.js'

let blueprint = [
  {
    type: 'section_title',
    text: '個人資料',
  },
  {
    key: 'email',
    type: 'input',
    div: 2,
    disabled: true,
    required: true,
    label: 'E-mail',
    placeholder: 'E-mail',
    check (val) {
      if(!val) return '必填';
      if(!isEmail(val)) return 'E-mail無效';
    },
  },
  {
    key: 'name',
    type: 'input',
    div: 2,
    required: true,
    label: '姓名',
    placeholder: '姓名',
    check (val) {
      if(!val) return '必填';
    },
  },
  {
    key: 'department_of_id',
    type: 'select',
    div: 2,
    required: true,
    label: '系所',
    placeholder: '系所',
    check (val) {
      if(!val) return '必填';
    },
  },
  {
    key: 'tel',
    type: 'input',
    div: 2,
    label: '聯絡電話',
    placeholder: '聯絡電話',
    check (val) {
      if(val && !isPhone(val)) return '聯絡電話格式無效';
    },
  },

  { type: 'hr' },

  {
    type: 'section_title',
    text: '密碼設定',
    sub_text: '*密碼最少為6碼',
  },
  {
    key: 'password',
    type: 'password',
    div: 2,
    label: '密碼',
    check (val) {
    },
  },
  {
    key: 'password_confirmation',
    type: 'password',
    div: 2,
    label: '密碼確認',
    check (val, curFormData) {
      if(curFormData.password && !val) return '必填';
    },
  },
];

export default blueprint;